module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-inlearno",
    class: {
      'spinner-inlearno_height': _vm.height
    }
  }, [_c('svg', {
    staticClass: "spinner-inlearno__svg",
    staticStyle: {
      "enable-background": "new 0 0 100 100"
    },
    attrs: {
      "version": "1.1",
      "id": "spinners-inlearno",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 100 100",
      "xml:space": "preserve",
      "width": _vm.size
    }
  }, [_c('path', {
    staticClass: "spinner-inlearno__circle",
    attrs: {
      "d": "M49.9,0.8C22.7,0.8,0.7,22.8,0.7,50c0,27.2,22,49.3,49.2,49.3S99.2,77.1,99.2,50C99.2,22.8,77.2,0.8,49.9,0.8zM50,91.7C27,91.7,8.3,73,8.3,50c0-20.7,15.1-37.8,34.8-41.1l6.8,9.4l6.8-9.4C76.6,12.2,91.6,29.4,91.6,50C91.6,73,73,91.7,50,91.7z"
    }
  }), _c('path', {
    staticClass: "ispinner-inlearno__logo",
    attrs: {
      "d": "M37.2,67h-8.5V45.8h8.5V67z M31.1,33h3.7c1.6,0,2.4,0.8,2.4,2.5V38c0,1.7-0.8,2.5-2.4,2.5h-3.7c-1.7,0-2.5-0.8-2.5-2.5v-2.5C28.6,33.9,29.4,33,31.1,33L31.1,33z M71.4,34.5v29.4c0,2.1-1,3.1-3.1,3.1h-4.2c-0.8,0-1.5-0.2-2-0.6c-0.5-0.4-1-1.1-1.5-2L53,50.4c0,0-1.6-3.4-2.1-5.3h-0.4c0.3,1.9,0.4,3.8,0.4,5.6V67h-8.2V37.6c0-2.1,1-3.1,3.1-3.1h4.1c0.8,0,1.5,0.2,2,0.6c0.5,0.4,0.9,1.1,1.5,2l7.4,13.4c0.8,1.4,1.6,3.2,2.4,5.4h0.4c-0.2-2.2-0.3-4.1-0.4-5.7V34.5L71.4,34.5L71.4,34.5z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f6d3c1","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spinners/inlearno/component.vue
// module id = 385f5d4b9172ae06ad15
// module chunks = 89